import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-params-list',
  templateUrl: './params-list.component.html',
  styleUrls: ['./params-list.component.css']
})
export class ParamsListComponent implements OnInit {

  form: any | FormGroup
  paramData:any = []

  singleParam:any = []
  cid:any
  formSubmit = false;
  isLoading: any = false
  deleteId: any
  paramId: any
  paramTypes = [
    "USERPARAMS",
    "CUSTREG",
    "ADMIN",
    'MDPARAMS',
    'USERTYPE',
    'PRODUCTPARAMS',
    "TICKETPARAM",
    "TASKPARAM",
    "PROSPECT",
    "VENDOR",
    "ASSETSTATUS"
  ]

  type = [
    "Input",
    "Checkbox",
    "File",
    "Image",
    "Dropdown"
  ]

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }


  searchKey: any = ""
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  dynamicData: any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }
  userCreds: any
  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    // this.userCreds = JSON.parse(sessionStorage.getItem('userCreds')!);

    // for(let list of this.userCreds.rolePrevilages){
    //   for(let screenPrivilegeList of list.screenPrivilegeList){
    //     if(screenPrivilegeList.name == messages[messages.length-1]){
    //       console.log(screenPrivilegeList)
    //       this.actionControls.isAdd = screenPrivilegeList.add
    //       this.actionControls.isView = screenPrivilegeList.view
    //       this.actionControls.isDelete = screenPrivilegeList.delete
    //       this.actionControls.isModify = screenPrivilegeList.modify
    //     }
    //   }
    // }

    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    // this.getParamsData()
    this.getAllPredefinedParameterWithPagination(this.pageNumber,this.recordsPerPage)

    this.form = this.fb.group({
      name: ['',[Validators.required]],
      type: ['',[Validators.required]],
      isMandatory: [''],
      boxType: [''],
      DropdownType: [''],
      predefinedParameterId: [''],
      api: [''],
      possibleValue:this.fb.array([])
    }) 


    this.addpossibleValue()
    this.dynamicGetAll()
  }

  dynamicGetAll(){
    this.generic_service.dynamicGetAll().subscribe(
      (res:any)=> {
        console.log(res);
        this.dynamicData = res.response

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  dropdownChange(){
    this.form.patchValue({
      api: ""
    })
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.pageNumber = event.page;

    if(this.searchKey != ""){
      this.getPredefinedParameterByWildSearch(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllPredefinedParameterWithPagination(this.pageNumber,this.recordsPerPage)
    }
  }

  get paramArr(){
    return this.form.get('possibleValue') as FormArray;
  }

  possibleValue(){
    return this.fb.group({
      "key":['']
    })
  }
  addpossibleValue(){
    this.paramArr.push(this.possibleValue())
  }
  
  removepossibleValue(index: number){
    this.paramArr.removeAt(index)
  }

  addParam(){
    this.formSubmit = true;
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }

    let arr = []
    arr = this.form.get('possibleValue').value
    let possible = []

    for(var i = 0; arr.length > i;i++){
      if(arr[i].key != ""){
        possible.push(arr[i].key)
      }
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "name": String(this.form.get('name').value),
      "api": String(this.form.get('api').value),
      "type": String(this.form.get('type').value),
      "boxType": this.form.get('boxType').value,
      "isMandatory": this.form.get('isMandatory').value,
      "possibleValue": possible,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.addParam(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllPredefinedParameterWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
        this.formSubmit = false;
        this.form.reset()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  // getParamsData(){
  //   this.isLoading = true

  //   this.generic_service.getParams().subscribe(
  //     (res:any)=> {
  //       console.log(res)
  //       this.paramData = res.response
  //       this.totalRecords = res.response.length;
  //       this.isLoading = false

  //     },
  //     (err:any)=>{
  //       console.log(err)
  //     }
  //   )
  // }

  getParamById(id:any){
    console.log(id)
    this.generic_service.getParamById(id).subscribe(
      (response:any)=>{
        this.singleParam = []
        this.singleParam.push(response.response)
        this.getByApiName(response.response.name)
        console.log(response)
        this.form.patchValue({
          name: response.response.name,
          type: response.response.type,
          predefinedParameterId: response.response.predefinedParameterId,
          boxType: response.response.boxType,
          isMandatory: response.response.isMandatory,
        })
        for(var i=0; i<response.response.possibleValue.length; i++){
          let obj = this.fb.group({
            "key":[response.response.possibleValue[i]]
          })
          this.paramArr.push(obj)
        }
      }
    )
  }

  getByApiName(name: any){
    this.generic_service.getByApiName(name).subscribe(
      (res:any)=>{
        console.log(res)
      },err=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  removepossibleValue1(){
    this.paramArr.clear()
  }

  getParamById1(id:any){
    this.paramId = id
    this.form.reset()
    this.removepossibleValue1()
    this.generic_service.getParamById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.form.patchValue({
          name: response.response.name,
          type: response.response.type,
          predefinedParameterId: response.response.predefinedParameterId,
          boxType: response.response.boxType,
          isMandatory: response.response.isMandatory,
        })
        for(var i=0; i<response.response.possibleValue.length; i++){
          let obj = this.fb.group({
            "key":[response.response.possibleValue[i]]
          })
          this.paramArr.push(obj)
        }
        console.log(this.form.value)

      },
      (error)=>{
        console.log(error)
      }
    )
  }


  boxTypeChange(){
    if(this.form.get('boxType').value != "Dropdown"){
      while (this.paramArr.length !== 0) {
        this.paramArr.removeAt(0)
      }
    }else{
      this.addpossibleValue() 
    }
  }

  deleteParam(){
    this.generic_service.deleteParam(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getAllPredefinedParameterWithPagination(this.pageNumber,this.recordsPerPage)
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  updateParam(){
    if(!this.form.valid){
      console.log(this.form.value)
      return
    }

    let arr = []
    arr = this.form.get('possibleValue').value
    let possible = []

    for(var i = 0; arr.length > i;i++){
      if(arr[i].key != ""){
        possible.push(arr[i].key)
      }
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "name": String(this.form.get('name').value),
      "predefinedParameterId": this.form.get('predefinedParameterId').value,
      "type": String(this.form.get('type').value),
      "boxType": this.form.get('boxType').value,
      "isMandatory": this.form.get('isMandatory').value,
      "possibleValue": possible,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateParam(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllPredefinedParameterWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }


  getAllPredefinedParameterWithPagination(pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllPredefinedParameterWithPagination(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.paramData = response.response.predefinedParameterList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false

      }
    )
  }


  getPredefinedParameterByWildSearch(pageNumber: any,recordsPerPage: any){
    if(this.searchKey != ""){
      this.isLoading = true
  
      this.generic_service.getPredefinedParameterByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          this.paramData = response.response.predefinedParameterList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false
  
        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllPredefinedParameterWithPagination(this.pageNumber,this.recordsPerPage)
    }
  }
  
  refreshSearch(){
    this.searchKey = ""
    this.getAllPredefinedParameterWithPagination(this.pageNumber,this.recordsPerPage)
  }

}
